<template>
	<div id="songs-side" :class="{ 'side-opened': sideOpened }" @scroll="handleScroll">
		<div class="search-external-loader" v-if="searchProcessing">{{ $t('search.searching') }} ...</div>
		<div class="search-external-info" v-if="!searchProcessing && externalSongs.length === 0">
			<IconArrowUp />
			{{ $t('search.helper1') }}
			<br><br>
			{{ $t('search.helper2') }}
			<button type="button" class="create-song" @click="createSong"><IconPlus /><span>{{ $t('search.createNewSongButton') }}</span></button>
		</div>
		<ExternalSongs v-if="!searchProcessing" />
		<br><br><br>
	</div>
</template>

<script>
	import ExternalSongs from "./ExternalSongs";
	import { SongService } from "@/services/SongService";
	import { mapState } from "vuex";
	import IconArrowUp from "@/components/icons/IconArrowUp"
	import IconPlus from "@/components/icons/IconPlus"

	export default {
		components: {
			ExternalSongs, IconArrowUp, IconPlus
		},
		computed: {
			...mapState([ "searchProcessing", "sideOpened", "externalSongs", "currentUser" ])
		},
		methods: {
			createSong() {
				if (Object.values(this.$store.state.songs).length >= 5 && this.currentUser.isAnonymous) {
					this.$modal.show("login-registration");
					return;
				} else if (Object.values(this.$store.state.songs).length >= 20 && (this.$store.state.datetimeMembershipExpire === null || this.$store.state.datetimeMembershipExpire < new Date)) {
					this.$modal.show("need-membership");
					return;
				}

				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", false);
				this.$store.commit("setSongsSorting", false);
				this.$store.commit("setSongsFilter", {
					playlist: null,
					author: null,
					onlyQueue: false
				});

				const song = SongService.createSong(this.$i18n.locale);
				setTimeout(() => {
					this.$store.commit("setCurrentSong", song);
					this.$router.push({ name: "zpevnik-song", params: { song: song.songId } });
				}, 500);
				setTimeout(() => { this.$modal.show("edit-song"); }, 500);
			},
			handleScroll() {
				this.$emit("scroll")
			}
		}
	}
</script>

<style lang="scss" scoped>
	#songs-side {
		background-color: #264653;
		height: calc(100vh - 50px);
		width: 260px;
		position: fixed;
		z-index: 1;
		top: 100px;
		top: calc(constant(safe-area-inset-top) + 100px);
		top: calc(env(safe-area-inset-top) + 100px);
		left: -260px;
		overflow-x: hidden;

		-webkit-transition: height 0.2s, left 0.2s;
		-moz-transition: height 0.2s, left 0.2s;
		-o-transition: height 0.2s, left 0.2s;
		transition: height 0.2s, left 0.2s;

		&.side-opened {
			left: 0;
		}

		&::-webkit-scrollbar {
			width: 8px;
		}

		&::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
			background-color: rgba(59, 115, 135, 0.26);
		}

		&::-webkit-scrollbar-thumb {
			background-color: rgba(42, 157, 143, 0.7);
		}

		.search-external-info {
			color: rgba(255, 255, 255, 0.55);
			text-shadow: 1px 1px rgba(255, 255, 255, 0.07);
			top: 40px;
			padding: 15px;
			line-height: 1.4em;

			.icon-arrow-up {
				fill: rgba(255, 255, 255, 0.16);
				margin: 0 0 10px 10px;
			}
		}

		.search-external-loader {
			color: rgba(255, 255, 255, 0.55);
			text-shadow: 1px 1px rgba(255, 255, 255, 0.07);
			top: 40px;
			padding: 15px;
			line-height: 1.4em;
		}

		button.create-song {
			font-weight: 100;
			padding: 0 20px;
			border: 0;
			margin-top: 40px;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 230px;

			&:hover {
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}

			.icon-plus {
				width: 18px;
				margin: 5px 0 0 -7px;
				float: left;
				position: absolute;
				fill: rgba(255, 255, 255, 0.79);
			}

			span {
				margin-left: 18px;
			}
		}
	}
</style>
